module.exports = __webpack_public_path__ + "img/hourglass-02.31b6e708.svg";